module.exports = "https://cdn.hellotech.com/client-assets/phones_and_tablets_tablet_ccb803579b0e391692685186a4ce83b5.webp";